<template>
  <div class="bg relative h-full min-h-screen bg-class" :style="{ backgroundImage: 'url(' + require('@/assets/BG.png') + ')' }">
    

    <div class="p-10" style="max-width: 1200px; margin: auto;">
      <router-view />
    </div>
    <div class="pt-10"></div>
    <TheNavBar />
  </div>

  
</template>

<script>
import TheNavBar from '@/components/TheNavBar';
import TheFooter from '@/components/gem-farm/TheFooter';
import TheCat from '@/components/gem-farm/TheCat';
export default {
  components: { TheCat, TheFooter, TheNavBar },
};
</script>

<style>

input[type='radio']:checked + span {
  @apply text-black;
}

.bg-class{
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

</style>
